import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React from 'react';
import { capitalizeString, generateBreakpointsVariants, Primitive, styled } from '@miro-site/ui-styled-engine';
import { jsx as _jsx } from "react/jsx-runtime";
var HideStitched = styled(Primitive.div, {
  variants: generateBreakpointsVariants({
    display: 'none'
  })
});
var Hide = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var from = _ref.from,
      upTo = _ref.upTo,
      on = _ref.on,
      children = _ref.children,
      asChild = _ref.asChild;

  var getVariants = function getVariants() {
    var variants = {};

    if (from) {
      variants["from".concat(capitalizeString(from))] = true;
    }

    if (upTo) {
      variants["upTo".concat(capitalizeString(upTo))] = true;
    }

    if (on) {
      // "on" can be a string or array; to ensure it's a 1d array we wrap and flatten it
      var onBreakpoints = [on].flat();

      var _iterator = _createForOfIteratorHelper(onBreakpoints),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var br = _step.value;
          variants["on".concat(capitalizeString(br))] = true;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    return variants;
  };

  if (!children) {
    return null;
  }

  return /*#__PURE__*/_jsx(HideStitched, _objectSpread(_objectSpread({
    asChild: asChild || undefined,
    ref: ref
  }, getVariants()), {}, {
    children: children
  }));
});
Hide.displayName = 'Hide';
export { Hide };